import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, BookOpen, FileCheck, Award } from 'lucide-react';
import { courseRoutes } from '../../data/courseRoutes';

const levels = [
  { key: 'awareness',      label: 'Awareness Training',  icon: BookOpen,   shortLabel: 'Awareness' },
  { key: 'internalAuditor', label: 'Internal Auditor',   icon: FileCheck,  shortLabel: 'Internal Auditor' },
  { key: 'leadAuditor',    label: 'Lead Auditor',         icon: Award,      shortLabel: 'Lead Auditor' },
];

export const ISOProgressionPath = ({ standard, currentLevel }) => {
  const routes = courseRoutes[standard.slug];
  if (!routes) return null;

  // Only render levels that have a route
  const availableLevels = levels.filter((l) => routes[l.key]);

  return (
    <section className="bg-white border-b border-gray-100 py-4">
      <div className="max-w-7xl mx-auto px-4">
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">
          {standard.code} Training Path
        </p>
        <div className="flex flex-wrap items-center gap-1">
          {availableLevels.map((level, index) => {
            const Icon = level.icon;
            const isCurrent = level.key === currentLevel;
            const url = routes[level.key];

            return (
              <React.Fragment key={level.key}>
                {isCurrent ? (
                  <span
                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold bg-gradient-to-r ${standard.color.gradient} text-white shadow-sm`}
                  >
                    <Icon className="h-3.5 w-3.5" />
                    {level.shortLabel}
                  </span>
                ) : (
                  <Link
                    to={url}
                    className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium border ${standard.color.border} ${standard.color.text} ${standard.color.bg} ${standard.color.hover} transition-colors`}
                  >
                    <Icon className="h-3.5 w-3.5" />
                    {level.shortLabel}
                  </Link>
                )}
                {index < availableLevels.length - 1 && (
                  <ChevronRight className="h-4 w-4 text-gray-300 flex-shrink-0" />
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};
